import { enClientPortalValuationDCFPage } from './Valuation/ValuationDCF/ValuationDCFPage'
import { enClientPortalValuationIncomePage } from './Valuation/ValuationIncomePage/ValuationIncomePage'
import { enClientPortalValuationPageLayout } from './Valuation/ValuationLayout/ValuationPageLayout'
import { enClientPortalValuationMarketData } from './Valuation/ValuationMarketData'
import { enClientPortalValuationPlausibility } from './Valuation/ValuationPlausibility'
import { enClientPortalValuationTenantListPage } from './Valuation/ValuationTenantList/ValuationTenantListPage'
import { enClientPortalValuationOverviewCommon } from './Valuation/ValuationOverview'

export const enClientPortalValuationCommon = {
    valuationPageLayout: enClientPortalValuationPageLayout,
    valuationOverview: enClientPortalValuationOverviewCommon.valuationOverview,
    valuationIncomePage: enClientPortalValuationIncomePage,
    valuationTenantListPage: enClientPortalValuationTenantListPage,
    valuationDCFPage: enClientPortalValuationDCFPage,
    valuationMarketData: enClientPortalValuationMarketData,
    valuationPlausibility: enClientPortalValuationPlausibility,
}
